import React from 'react';
import classNames from 'classnames';
import StyledLabel from '../../styled-label';

const namespace = 'ui-pdp-inspection-vehicles-tag';

/**
 * Handles the click event, prevents the default action, and smoothly scrolls the target element into view.
 *
 * @param {Event} e - The click event object.
 * @param {string} target - The ID of the target element to scroll into view.
 */
const onClickHandler = (e, target) => {
  e.preventDefault();
  const element = document.getElementById(target);

  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

/**
 * Generates the content for an inspection badge.
 *
 * @param {Object} tag_action - The action object containing the target and label for the badge.
 * @param {boolean} clickable - Determines if the badge should be clickable.
 * @returns {JSX.Element} The styled label component for the inspection badge.
 */
export function getInspectionBadgeContent(tag_action, clickable) {
  return (
    <StyledLabel
      onClick={event => onClickHandler(event, tag_action.target)}
      className={classNames(`${namespace}__inspection-badge`, {
        clickable,
      })}
      {...tag_action.label}
    />
  );
}
